import Guard from '@/services/middleware'

const WebhooksHome = () => import('@/views/dash/settings/webhooks/Home.vue')

export default [
    {
        path: '/webhooks',
        name: 'webhooks.home',
        component: WebhooksHome,
        meta: { title: 'Webhooks de canal', permission: 2, module: 'mod_integration' },
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
    },
]
